module.exports = __webpack_public_path__ + "static/media/boy-13.9c3e1bd0.svg";